import { IRootState } from '../../app/store';

export const selectEbpcAsyncStatus = (state: IRootState) =>
    state.ebpcSkills.asyncStatus;
export const selectskillsDetails = (state: IRootState) =>
    state.ebpcSkills.ebpcSkillsDetails;
export const selectStatusCode = (state: IRootState) =>
    state.ebpcSkills.statusCode;
